import {
  SidePanel,
  ButtonPrimary,
  ButtonSecondary,
  PermissionEnum,
} from '@ui/src';
import CategoryForm from '../../../components/charts/charts-panel/charts-panel-category';
import useCategoryCreate from './hooks/use-create';

import cn from '../styles.module.css';

const CategoryCreateHOC = (): React.JSX.Element => {
  const {
    typeOptions,
    requestInProgress,
    activePermissions,
    control,
    errors,
    onSubmit,
    panelIsOpen,
    handleClose,
  } = useCategoryCreate();

  return (
    <SidePanel
      closeOnClickOutside={false}
      isOpen={panelIsOpen}
      onClose={handleClose}
      parent={document.getElementById('chart-modal') as HTMLElement}
      title="Category Add"
      className={cn.chartSidePanel}
      sidepanelExpandedKey="charts-category-create"
      footer={
        <>
          {activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_ADD_CATEGORY_ACTION,
          ) && (
            <ButtonPrimary
              text={requestInProgress ? 'Loading...' : 'Save'}
              disabled={requestInProgress}
              onClick={onSubmit}
            />
          )}
          <ButtonSecondary text="Close" onClick={handleClose} />
        </>
      }
    >
      <CategoryForm
        control={control}
        typeOptions={typeOptions}
        errors={errors}
      />
    </SidePanel>
  );
};

export default CategoryCreateHOC;
